<ul class="grid grid-cols-1 gap-4 sm:gap-6 sm:grid-cols-2">
  @for (orgaUser of orgaUsers$ | async; track orgaUser) {
    <li class="relative col-span-1">
      <app-orga-user-card [orgaUser]="orgaUser" [role]="(role$ | async)!"></app-orga-user-card>
    </li>
  }
</ul>

@if (orga$ | async; as orga) {
  @if (showAddUserButton | async) {
    <app-divider-button
      (buttonClick)="addUserToOrganisation()"
      buttonText="Neue Mitarbeiter:in anlegen"
    >
      <app-ng-icon class="text-fg-faint" strokeWidth="3" name="heroPlus"></app-ng-icon>
    </app-divider-button>
  }
}

@if (newOrgaUserSlideOverOpen) {
  <app-orga-user-slide-over (cancel)="closeSlideOver()"></app-orga-user-slide-over>
}
